import {
  RECEIVE_CAPS,
  receiveCapsI,
  RECEIVE_UPDATED_CAP,
  receiveUpdatedCapI,
  receiveNewCapI,
  RECEIVE_NEW_CAP,
  RECEIVE_DELETE_CAP,
  receiveDeleteCapI,
} from "../actions/Caps";
import { AllCaps, Cap } from "../../types/caps";

type UWDataActionType =
  | receiveCapsI
  | receiveUpdatedCapI
  | receiveNewCapI
  | receiveDeleteCapI;
export type CapsState = {
  data: AllCaps | null;
  byID: Record<number, Cap>;
  receivedAt?: number;
  fetching: boolean;
};
const defaultState = {
  data: null,
  byID: {},
  fetching: false,
};

export default function Caps(
  state: CapsState = defaultState,
  action: UWDataActionType
) {
  switch (action.type) {
    case RECEIVE_CAPS:
      const allCaps = action.data;
      return {
        ...state,
        data: allCaps,
        byID: [...allCaps].reduce<Record<number, Cap>>((current, caps) => {
          current[caps.capId] = caps as Cap;
          return current;
        }, {}),
        receivedAt: Date.now(),
        fetching: false,
      };
    case RECEIVE_UPDATED_CAP:
      const updateCap: Cap = action.data;
      return {
        ...state,
        data: state.data?.map((cap) =>
          cap.capId === updateCap.capId ? { ...cap, ...updateCap } : cap
        ),
        byID: { ...state.byID, [updateCap.capId]: updateCap },
      };
    case RECEIVE_NEW_CAP:
      const newCap = action.data;
      //TODO, make add the data object to the array
      return {
        ...state,
        data: state.data?.concat(newCap),
        byID: { ...state.byID, [newCap.capId]: newCap },
      };
    case RECEIVE_DELETE_CAP:
      const capID = action.capID;
      return {
        ...state,
        data: state.data?.filter((cap) => cap.capId !== capID),
      };

    default:
      return state;
  }
}
